import React from "react";
import { Link } from "react-router-dom";

const SiteFooter = () => (
  <footer className="bg-[#0C1510] border-t border-[#ffffff14] text-[#F3EEE3]/70">
    <div className="max-w-[1500px] mx-auto px-5 md:px-8 py-14 grid md:grid-cols-5 gap-10">
      <div className="md:col-span-2">
        <p className="font-display text-2xl text-[#F3EEE3]">Deer Park Estates</p>
        <p className="eyebrow text-[0.55rem] text-[#F3EEE3]/50 mt-2">Spruce Grove · Alberta · 20 min west of Edmonton</p>
        <p className="text-sm mt-5 max-w-md leading-relaxed">
          New homes and estate lots in a master-planned community in Spruce Grove, Alberta — delivered in stages with
          parks, ponds, trails and a secured commercial centre, 20–25 minutes from West Edmonton on Highway 16.
        </p>
      </div>
      <div>
        <p className="eyebrow text-[0.55rem] text-[#C9B79C] mb-4">Buying</p>
        <ul className="space-y-2 text-sm">
          <li><Link to="/new-homes-edmonton" className="hover:text-[#F3EEE3]" data-testid="footer-new-homes-edmonton">New Homes near Edmonton</Link></li>
          <li><Link to="/lots-for-sale-spruce-grove" className="hover:text-[#F3EEE3]" data-testid="footer-lots-spruce-grove">Lots for Sale in Spruce Grove</Link></li>
          <li><Link to="/build-your-home-alberta" className="hover:text-[#F3EEE3]" data-testid="footer-build-your-home">Build Your Custom Home</Link></li>
          <li><Link to="/builders" className="hover:text-[#F3EEE3]">Custom Home Builders</Link></li>
        </ul>
      </div>
      <div>
        <p className="eyebrow text-[0.55rem] text-[#C9B79C] mb-4">Explore</p>
        <ul className="space-y-2 text-sm">
          <li><Link to="/master-plan" className="hover:text-[#F3EEE3]">Interactive Master Plan</Link></li>
          <li><Link to="/available-land" className="hover:text-[#F3EEE3]">Available Land</Link></li>
          <li><Link to="/stages" className="hover:text-[#F3EEE3]">Development Stages</Link></li>
        </ul>
      </div>
      <div>
        <p className="eyebrow text-[0.55rem] text-[#C9B79C] mb-4">Invest</p>
        <ul className="space-y-2 text-sm">
          <li><Link to="/contact" className="hover:text-[#F3EEE3]">Request Information</Link></li>
          <li><Link to="/login" className="hover:text-[#F3EEE3]">Investor Portal</Link></li>
          <li><Link to="/commercial" className="hover:text-[#F3EEE3]">Commercial Centre</Link></li>
          <li><Link to="/apartment" className="hover:text-[#F3EEE3]">Apartment Project</Link></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-[#ffffff12] px-5 md:px-8 py-5 max-w-[1500px] mx-auto flex flex-col sm:flex-row justify-between gap-2 text-[0.68rem] text-[#F3EEE3]/40">
      <span>© {new Date().getFullYear()} Deer Park Estates. All rights reserved.</span>
      <span>Conceptual & preliminary information — figures estimated and subject to approval and change.</span>
    </div>
    <div className="px-5 md:px-8 pb-5 max-w-[1500px] mx-auto text-[0.68rem] text-[#F3EEE3]/40">
      <span>
        Website by{" "}
        <a
          href="https://webempire.ca/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#F3EEE3]/60 hover:text-[#E8B86D] underline-offset-2 hover:underline transition-colors"
          data-testid="footer-webempire-link"
        >
          Web Empire
        </a>
      </span>
    </div>
  </footer>
);

export default SiteFooter;
